import React from 'react';
import { placePreview, PREVIEW_WIDTH, type PreviewPlacement } from './previewPlacement';

// Measures the list (anchor) and the preview card, and keeps the card inside the
// window. The card height changes when its content arrives, so it is observed.
export const usePreviewPlacement = (anchorRef: React.RefObject<HTMLElement>) => {
  const [previewEl, setPreviewEl] = React.useState<HTMLElement | null>(null);
  const [placement, setPlacement] = React.useState<PreviewPlacement>({
    side: 'right',
    width: PREVIEW_WIDTH,
    offsetTop: 0,
  });

  React.useLayoutEffect(() => {
    const anchor = anchorRef.current;
    if (!anchor || !previewEl) return;

    const measure = () => {
      const next = placePreview(
        anchor.getBoundingClientRect(),
        previewEl.offsetHeight,
        { width: window.innerWidth, height: window.innerHeight },
      );
      setPlacement((current) => (
        current.side === next.side && current.width === next.width && current.offsetTop === next.offsetTop
          ? current
          : next
      ));
    };

    measure();
    if (typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(measure);
    observer.observe(previewEl);
    return () => observer.disconnect();
  }, [previewEl, anchorRef]);

  const style: React.CSSProperties = {
    width: placement.width,
    top: placement.offsetTop,
    ...(placement.side === 'right' ? { left: '100%', marginLeft: 8 } : { right: '100%', marginRight: 8 }),
  };

  return { setPreviewEl, style };
};
